import * as React from 'react';
import PropTypes from 'prop-types';
import { SimpleDialog } from './Dialog';
import DeletableChips from '../Chips/DeletableChips'

SimpleDialog.propTypes = {
    onClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    selectedValue: PropTypes.string.isRequired,
};

export default function SimpleDialogDemo(props) {
    const { open, onClose, filterData, setFilterData,
        chipsState,
        setActiveFilters,
        activeFilters, handleSelectChange, setFilters
    } = props;

    return (
        <div>
            <br />

            <SimpleDialog
                chipsState={chipsState}
                open={open}
                onClose={onClose}
                filterData={filterData}
                setFilterData={setFilterData}
                setActiveFilters={setActiveFilters}
                activeFilters={activeFilters}
                handleSelectChange={handleSelectChange}
                setFilters={setFilters}
            />
        </div>
    );
}
